
import { auth, db } from '../lib/firebase';
import firebase from 'firebase/compat/app';
import { UserProfile, UserRole } from '../types';

export const createUserProfile = async (user: firebase.User, role: UserRole = 'CLIENT', tenantId?: string): Promise<void> => {
  const userRef = db.collection('users').doc(user.uid);
  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const newUser: UserProfile = {
      uid: user.uid,
      email: user.email || '',
      displayName: user.displayName || 'New User',
      role,
      createdAt: Date.now(),
      tenantId: tenantId || 'default', // Assign User to Tenant
    };
    await userRef.set(newUser);
  }
};

export const loginWithGoogle = async (tenantId?: string): Promise<firebase.User | null> => {
  const provider = new firebase.auth.GoogleAuthProvider();
  try {
    const result = await auth.signInWithPopup(provider);
    if (result.user) {
        await createUserProfile(result.user, 'CLIENT', tenantId);
        return result.user;
    }
    return null;
  } catch (error) {
    console.error("Login failed", error);
    throw error;
  }
};
